// extracted by mini-css-extract-plugin
export var FlowDiagram = "styles-module--FlowDiagram--1X-AV";